import Okta from 'providers/Okta';
import Tokens from 'providers/Tokens';

export default async scope => {
  const auth = Okta();
  const token = await Tokens.request(auth, scope);
  return token;
};
